import type { SocialMediaName } from "../external-referrer-metadata/getSocialMediaName.js";

export const TacticIdType = [ "direct", "referral", "organicSearch", "pr", "social" ] as const;
export type TacticIdType = typeof TacticIdType[ number ];

export const tacticIdMapping = {
  direct: "7013x000001xxxDAAQ",
  referral: "7013x000001xxxIAAQ",
  organicSearch: "7013x000001xxx8AAA",
  pr: "7013x000001y8XfAAI",
  social: ({
    linkedin: "7013x000002dd4HAAQ",
    facebook: "7013x000002dd4MAAQ",
    twitter: "7013x000002dd4RAAQ",
    youtube: "7013x000002dfbAAAQ",
  } as const satisfies Record<SocialMediaName, string>),
} as const;
